import React from 'react';
import WorkshopsUserEventsTable from '../Common/MoodleEventBooking/WorkshopsUserEventsTable';
import { useAuthenticateUser } from '../../hooks/useAuthenticateUser';

export default function WorkshopsUpcomingEventsPage() {
  const { email } = useAuthenticateUser();

  if (!email) {
    return <div className="p-4">Unable to determine user email.</div>;
  }

  return (
    <div className="p-4 h-full min-h-0 flex flex-col gap-4">
      <div>
        <h1 className="text-2xl font-semibold">Upcoming Events</h1>
        <p className="text-sm opacity-70">
          View upcoming workshop events.
        </p>
      </div>

      <div className="flex-1 min-h-0">
        <WorkshopsUserEventsTable
          email={email}
          defaultTimePreset="future_90"
          allowedDirection="future"
          restrictToUserAssociation={false}
          eventRouteBase="/workshops/upcoming-events"
        />
      </div>
    </div>
  );
}